<template>
  <div class="page page-roadshow-list">
    <div class="list-options v-mt-sm">
      <a-form layout="inline" class="options-form">
        <a-row :gutter="24">
          <a-col span="8">
            <a-form-item :colon="false" label="文档类型">
              <!-- <a-input placeholder="文档名称" @keyup.enter="handleSearch" allow-clear v-model="form.reportName" size="default" style="width: 200px" /> -->
              <a-select placeholder="请选择" :filter-option="filterOption" show-search v-model="form.fileType" size="default" style="width: 200px" allowClear>
                <!-- <a-select-option :value="1">预算文件</a-select-option> -->
                <a-select-option :value="5">项目报告</a-select-option>
                <a-select-option :value="6">项目变更</a-select-option>
                <a-select-option :value="7">任务成果文件</a-select-option>
                <a-select-option :value="8">项目协议</a-select-option>
                <a-select-option :value="9">评审会议文件</a-select-option>
                <a-select-option :value="101">项目合作协议及承诺书</a-select-option>
                <a-select-option :value="102">合作申请书</a-select-option>
                <a-select-option :value="103">项目预算表</a-select-option>
                <a-select-option :value="104">其他项目文件(合作项目)</a-select-option>
                <a-select-option :value="2201">学生统计表</a-select-option>
                <a-select-option :value="2301">培训班学员名单</a-select-option>
                <a-select-option :value="2501">项目材料</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col span="8">
            <a-form-item :colon="false" label="项目名称"><a-input placeholder="项目名称" @keyup.enter="handleSearch" allow-clear v-model="form.projectName" size="default" style="width: 200px" /></a-form-item>
          </a-col>
          <a-col span="8">
            <a-form-item :colon="false" label="文件类型">
              <a-select placeholder="请选择" v-model="form.fileFormat" size="default" style="width: 200px" allowClear>
                <a-select-option value="word">word文档（doc, docx）</a-select-option>
                <a-select-option value="excel">excel文档（xls, xlsx）</a-select-option>
                <a-select-option value="ppt">ppt</a-select-option>
                <a-select-option value="pdf">pdf</a-select-option>
                <a-select-option value="image">图片</a-select-option>
                <a-select-option value="video">视频</a-select-option>
                <a-select-option value="compress">压缩文件（zip, rar, 7z）</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="flex items-center v-my-sm">
      <div class="v-ml-auto">
        <a-space>
          <a-button type="primary" icon="search" size="small" @click="handleSearch">查询</a-button>
          <!-- <a-button icon="plus" type="primary" size="small" @click="$router.push('add')">新增项目</a-button> -->
          <!-- <a-button icon="file-excel" type="danger" size="small" @click="$router.push('add')">导出</a-button> -->
        </a-space>
      </div>
    </div>
    <div class="list-table-container">
      <div class="list-toolbar flex items-center">
        <div class="list-toolbar-extra">
          共
          <span class="text-primary font-special">{{ pagination.total }}</span>
          条记录
        </div>
        <div class="list-pagination v-ml-auto">
          <a-pagination size="small" :current="pagination.page" :total="pagination.total" :pageSize="pagination.pageSize" show-size-changer show-quick-jumper @change="onPageChange" @showSizeChange="onPageChange" />
        </div>
      </div>
      <a-table class="list-table" size="small" :bordered="false" :pagination="false" :loading="loading" :data-source="list" :scroll="{ x: '100%' }" rowKey="uid">
        <a-table-column title="#" data-index="index" :width="60" align="center">
          <template slot-scope="text, record, index">
            {{ index + 1 }}
          </template>
        </a-table-column>
        <a-table-column title="项目名称" data-index="projectName" :width="320" :ellipsis="true" align="left">
          <template slot-scope="text, record">
            {{ record.projectName }}
          </template>
        </a-table-column>
        <a-table-column title="文件类型" data-index="fileType" :width="280" :ellipsis="true" align="left">
          <template slot-scope="text, record">
            <template v-if="record.fileType == 5">
              <span v-if="[1, 2, 3, 4].includes(record.belongType)">{{ record.reportName }}</span>
              <span v-else-if="record.belongType == 2101">监理报告</span>
              <span v-else-if="record.belongType == 2102">甲醛检测报告</span>
              <span v-else-if="record.belongType == 2103">签署收到房屋的签署单</span>
              <span v-else-if="record.belongType == 2104">入住仪式</span>
              <span v-else-if="record.belongType == 2105">项目设计图</span>
              <span v-else-if="record.belongType == 2106">改造前照片</span>
              <span v-else-if="record.belongType == 2107">改造中照片</span>
              <span v-else-if="record.belongType == 2108">改造后照片</span>
              <span v-else-if="record.belongType == 2109">项目改造报告</span>
              <span v-else-if="record.belongType == 2110">财务报告</span>
              <span v-else-if="record.belongType == 2209">其他项目报告</span>
              <span v-else-if="record.belongType == 2201">物品签收单</span>
              <span v-else-if="record.belongType == 2202">书籍发放仪式（领导发放照片）</span>
              <span v-else-if="record.belongType == 2203">书籍发放仪式（老师发放照片）</span>
              <span v-else-if="record.belongType == 2204">书籍发放仪式（学生发放照片）</span>
            </template>
            <span v-else-if="record.fileType == 101">项目合作协议及承诺书</span>
            <span v-else-if="record.fileType == 102">合作申请书</span>
            <span v-else-if="record.fileType == 103 || record.fileType == 1">项目预算表</span>
            <span v-else-if="record.fileType == 104">其他项目文件(合作项目)</span>
            <span v-else-if="record.fileType == 2201">学生统计表</span>
            <span v-else-if="record.fileType == 2301">培训班学员名单</span>
            <span v-else-if="record.fileType == 2501">项目材料</span>
            <span v-else-if="record.fileType == 8">项目协议</span>
            <span v-else-if="record.fileType == 6">项目变更</span>
          </template>
        </a-table-column>
        <a-table-column title="提交文件" data-index="files" :width="340" align="left">
          <template slot-scope="text, record">
            <file-container :img-size="[100, 55]" :files="record.files" :belongId="record.projectId" fileSign="P01" v-if="record.files && record.projectId"></file-container>
          </template>
        </a-table-column>
        <a-table-column title="提交人" data-index="creatorName" :width="150" align="left">
          <template slot-scope="text, record">
            {{ record.creatorName }}
          </template>
        </a-table-column>
        <a-table-column title="提交时间" data-index="submitTime" :width="130" align="left">
          <template slot-scope="text, record">
            {{ record.submitTime }}
          </template>
        </a-table-column>
      </a-table>
      <div class="list-toolbar flex items-center">
        <div class="list-toolbar-extra">
          共
          <span class="text-primary font-special">{{ pagination.total }}</span>
          条记录
        </div>
        <div class="list-pagination v-ml-auto">
          <a-pagination size="small" :current="pagination.page" :total="pagination.total" :pageSize="pagination.pageSize" show-size-changer show-quick-jumper @change="onPageChange" @showSizeChange="onPageChange" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const form = {
  projectName: '',
  fileType: undefined,
  fileFormat: undefined,
}
// import FileContainer from '@/views/common/file-container'
import { listDocs } from '@/api/project/common'
export default {
  data() {
    return {
      tab: '',
      loading: false,
      list: [],
      pagination: {
        page: 1,
        pageSize: 20,
        total: 0,
      },
      form: { ...form },
    }
  },
  methods: {
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    handleSearch() {
      this.load()
    },
    handleReset() {
      this.form.resetFields()
    },
    load(page = 1, pageSize = 20, sorter) {
      this.loading = true
      let params = {
        page,
        pageSize,
        sorter,
        ...this.form,
      }
      listDocs(params)
        .then(({ data }) => {
          if (data.success) {
            let { current, size, total, records } = data.result
            this.list = records
            this.pagination = {
              page: current,
              pageSize: size,
              total,
            }
          }
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    onPageChange(page, pageSize) {
      this.load(page, pageSize)
    },
  },
  mounted() {
    this.load()
  },
}
</script>

<style lang="stylus" scoped>
.ant-form-item-label
  min-width 100px
</style>
